'use client';

import React from 'react';
import Main from '@/components/ui/layout/main';
import { OurBuildRenovateProcess } from '@/components/ui/sections/OurBuildRenovateProcess';
import { ContactUsSection } from '../floor-plans/[floor-plan-name]/ui/ContactUsSection';
import { ProjectsHero } from './ui/ProjectsHero';
import ProjectsSection from './ui/ProjectsSection';

function ProjectsPage() {
  return (
    <>
      <ProjectsHero />
      <Main padding="py-0 px-0" sm="" md="" lg="">
        <ProjectsSection />
        <ContactUsSection />
        <OurBuildRenovateProcess />
      </Main>
    </>
  );
}

export default ProjectsPage;
